export default {
  CURRENT_USER ({ currentUser }) {
    return currentUser
  },
  IS_LOGGED_IN ({ loggedInState }) {
    return loggedInState
  }
}
